import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import PostPage from "./pages/PostPage";
import MyAccount from "./pages/MyAccount";
import PostReviewPage from "./pages/PostReviewPage";
import AskAnInsider from "./pages/AskAnInsider";
import MyNetworkPage from "./pages/MyNetworkPage";
import UserProfilePage from "./pages/UserProfilePage";

 


// ✅ Protected Route Component
function ProtectedRoute({ children }) {
  const { currentUser } = useAuth();
  return currentUser ? children : <Navigate to="/login" />;
}

function App() {
   return (
    <AuthProvider>
        <Router>
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/post/:postId" element={<PostPage />} />
            <Route path="/user/:userId" element={<UserProfilePage />} />
            <Route path="/my-network" element={<MyNetworkPage />} />
            <Route path="/my-account" element={
              <ProtectedRoute><MyAccount /></ProtectedRoute>
            } />
            <Route path="/post-review" element={
              <ProtectedRoute><PostReviewPage /></ProtectedRoute>
            } />
            <Route path="/ask" element={
              <ProtectedRoute><AskAnInsider /></ProtectedRoute>
            } />
          </Routes>
        </Router>
    </AuthProvider>
  );
}


export default App;
